import { render } from "./schedules_tab.vue?vue&type=template&id=a0c9a996"
import script from "./schedules_tab.vue?vue&type=script&lang=js"
export * from "./schedules_tab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__